/**
 * Duration-switch failures → honest copy.
 *
 * Key off the 409 body's `error` string. `source_unavailable` is a dead-end
 * for retry; only an explicit force re-scan can change length.
 */
import {
  isDurationRerenderError,
  isTwitchSignInRequiredError,
} from '../api/types';
import { STUDIO_COPY } from '../config';

export type MappedDurationRerender = {
  message: string;
  /** True only for expired source — UI offers an explicit force re-scan. */
  offerRescan: boolean;
  /** True when tapping the picker again may succeed. */
  retryable: boolean;
  code: string;
};

export function mapDurationRerenderError(error: unknown): MappedDurationRerender {
  if (isTwitchSignInRequiredError(error)) {
    return {
      message: STUDIO_COPY.durationSwitchAuth,
      offerRescan: false,
      retryable: false,
      code: 'authentication_required',
    };
  }
  if (isDurationRerenderError(error)) {
    if (error.error === 'source_unavailable') {
      return {
        message: STUDIO_COPY.durationSwitchSourceExpired,
        offerRescan: true,
        retryable: false,
        code: error.error,
      };
    }
    if (error.error === 'not_ready_to_rerender') {
      return {
        message: STUDIO_COPY.durationSwitchNotReady,
        offerRescan: false,
        retryable: true,
        code: error.error,
      };
    }
    if (error.error === 'feature_disabled') {
      return {
        message: STUDIO_COPY.durationSwitchDisabled,
        offerRescan: false,
        retryable: false,
        code: error.error,
      };
    }
    if (error.error === 'not_found') {
      return {
        message: STUDIO_COPY.durationSwitchNotFound,
        offerRescan: false,
        retryable: false,
        code: error.error,
      };
    }
    return {
      message: STUDIO_COPY.durationSwitchFailed,
      offerRescan: false,
      retryable: true,
      code: error.error,
    };
  }
  return {
    message: STUDIO_COPY.durationSwitchNetwork,
    offerRescan: false,
    retryable: true,
    code: 'network',
  };
}
